module.exports = __webpack_public_path__ + "media/images/arrows/bullet-white-3d97625e1705613aebdc158e0834dc8c.svg";